module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="icon-wrap"><i class="icon icon-material '+
((__t=( type ))==null?'':__t)+
'"></i></div><div class="content-wrap"><h5 class="title">'+
((__t=( headline ))==null?'':__t)+
'</h5><time class="timestamp" datetime="'+
((__t=( timestamp ))==null?'':__t)+
'">'+
((__t=( datetime ))==null?'':__t)+
'</time><p class="description">'+
((__t=( body ))==null?'':__t)+
'</p></div><div class="snippet-header input align-right"> ';
 if(read){ 
__p+=' <input data-click="click-read" class="read" id="'+
((__t=(readid))==null?'':__t)+
'" type="checkbox"> <label class="align-left" for="'+
((__t=(readid))==null?'':__t)+
'">'+
((__t=(i18n.tc("ControlNotifications", "Read")))==null?'':__t)+
'</label> ';
 } 
__p+=' <i data-click="click-delete" class="icon icon-material icon-labelled icon-delete-forever snippet-delete"></i></div>';
}
return __p;
};
